var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.$route.meta.title,"left-text":"返回","left-arrow":"","fixed":true,"placeholder":true},on:{"click-left":_vm.onClickLeft}})}
var staticRenderFns = []

export { render, staticRenderFns }